import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const DictionaryAddPopup = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DictionaryAddHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${toRem(32)};

  h3 {
    color: ${COLORS.FG.DEFAULT}

    font-size: ${toRem(16)};
    font-weight: 700;
    line-height: ${toRem(24)};
  }

  svg {
    cursor: pointer;
  }
`;

export const DictionaryAddContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(20)};

  .input--textarea .input__label {
    font-size:${toRem(12)};
  }
`;

export const DictionaryAddFooter = styled.div<{ isMobile: boolean }>`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  gap: ${toRem(16)};
  margin-top: ${toRem(30)};
  ${({ isMobile }) =>
    isMobile &&
    `
    flex-direction: column
    `}
`;
